module.exports = __webpack_public_path__ + "static/img/common.11d0441.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/common.png
// module id = rsKg
// module chunks = 7